export const ANT_BREAKPOINTS = {
    screenXS: 0,
    screenXSMin: 0,
    screenXSMax: 640,
  
    screenSM: 641,
    screenSMMin: 641,
    screenSMMax: 768,
  
    screenMD: 769,
    screenMDMin: 769,
    screenMDMax: 1024,
  
    screenLG: 1025,
    screenLGMin: 1025,
    screenLGMax: 1280,
  
    screenXL: 1281,
    screenXLMin: 1281,
    screenXLMax: 1440,
  
    screenXXL: 1441,
    screenXXLMin: 1441,
  };
  